var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 39,
    viewBox: "0 0 30 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 28.8H16.875V17.28H13.125V28.8ZM15 13.44C15.5312 13.44 15.9769 13.2557 16.3369 12.887C16.6969 12.5184 16.8762 12.0627 16.875 11.52C16.8738 10.9773 16.6938 10.5216 16.335 10.153C15.9762 9.78432 15.5312 9.6 15 9.6C14.4688 9.6 14.0238 9.78432 13.665 10.153C13.3063 10.5216 13.1263 10.9773 13.125 11.52C13.1238 12.0627 13.3038 12.519 13.665 12.889C14.0263 13.2589 14.4712 13.4426 15 13.44ZM15 38.4C10.6562 37.28 7.07 34.7277 4.24125 30.743C1.4125 26.7584 -0.00124917 22.3347 8.2818e-07 17.472V5.76L15 0L30 5.76V17.472C30 22.336 28.5863 26.7603 25.7588 30.745C22.9313 34.7296 19.345 37.2813 15 38.4ZM15 34.368C18.25 33.312 20.9375 31.2 23.0625 28.032C25.1875 24.864 26.25 21.344 26.25 17.472V8.4L15 4.08L3.75 8.4V17.472C3.75 21.344 4.8125 24.864 6.9375 28.032C9.0625 31.2 11.75 33.312 15 34.368Z",
    fill: "#383838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.96a3304ec7d430871a80e72a71d58df6.svg";
export { ForwardRef as ReactComponent };